module.exports = __webpack_public_path__ + "static/media/cancel_order_button.6e08776e.svg";